import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { useEffect, useState, useRef } from "react";

import { useCustomerViewModel } from "../../../viewmodels/operation/customer/useCustomerViewModel";

import DashboardLayout from "../../../components/layout/DashboardLayout";

import { useServiceCallViewModel } from "../../../viewmodels/operation/servicecall/useServiceCallViewModel";

import ScaleMakeAsyncSelect from "../../../components/common/ScaleMakeAsyncSelect";

import ScaleModelAsyncSelect from "../../../components/common/ScaleModelAsyncSelect";

import TechnicianAsyncSelect from "../../../components/common/TechnicianAsyncSelect";

const EditServiceCall = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const page = searchParams.get("page") ?? "1";
  const search = searchParams.get("search") ?? "";
  const state = searchParams.get("state") ?? "";
  const unassigned = searchParams.get("unassigned") ?? "false";

  const { id } = useParams();

  const { getServiceCallById, updateServiceCall } = useServiceCallViewModel();

  const { customers, setSearch } = useCustomerViewModel();

  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);

  const customerDropdownRef = useRef<any>(null);

  // ================= OUTSIDE CLICK =================
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        customerDropdownRef.current &&
        !customerDropdownRef.current.contains(event.target)
      ) {
        setShowCustomerDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // ================= FORM =================
  const [form, setForm] = useState<any>({
    id: "",

    date: "",
    orderNumber: "",
    no: 1,

    customerComment: "",

    scaleCertified: false,
    scaleUsedForTrade: false,

    tmvCertificateNo: "",

    customerId: "",

    customerName: "",
    customerEmail: "",
    customerAddress: "",
    customerPhoneName: "",
    customerPhoneNumber: "",

    signatureCustomerName: "",
    customerSignature: "",
    customerSignedDate: "",

    technicianName: "",

    technicianComment: "",
    technicianCommentDate: "",

    state: 0,
  });

  // ================= SCALE =================
  const [scales, setScales] = useState<any[]>([]);

  // ================= LOAN SCALE =================
  const [loanScale, setLoanScale] = useState<any[]>([]);

  // ================= TECHNICIANS =================
  const [technicians, setTechnicians] = useState<any[]>([]);

  // ================= LOAD =================
  useEffect(() => {
    if (id) {
      loadData();
    }
  }, [id]);

  const parseCapacity = (capacity: string) => {
    if (!capacity)
      return {
        capacityValue: "",
        division: "",
        capacityUnit: "",
      };

    const match = capacity.match(
      /^([\d.]+)(kg|g|mg|t|lb|oz)x([\d.]+)(kg|g|mg|t|lb|oz)$/i,
    );

    if (!match)
      return {
        capacityValue: "",
        division: "",
        capacityUnit: "",
      };

    return {
      capacityValue: match[1],

      capacityUnit: match[2],

      division: match[3],
    };
  };

  const loadData = async () => {
    const data = await getServiceCallById(id!);

    if (!data) return;

    setForm({
      id: data.id,

      date: data.date?.slice(0, 10) || "",

      orderNumber: data.orderNumber || "",

      no: data.no || 1,

      customerComment: data.customerComment || "",

      scaleCertified: data.scaleCertified,

      scaleUsedForTrade: data.scaleUsedForTrade,

      tmvCertificateNo: data.tmvCertificateNo || "",

      customerId: data.customerId || "",

      customerName: data.customerName || "",

      customerEmail: data.customerEmail || "",

      customerAddress: data.customerAddress || "",

      customerPhoneName: data.customerPhoneName || "",

      customerPhoneNumber: data.customerPhoneNumber || "",

      signatureCustomerName: data.signatureCustomerName || "",

      customerSignature: data.customerSignature || "",

      customerSignedDate: data.customerSignedDate?.slice(0, 16) || "",

      technicianName: data.technicianName || "",

      technicianComment: data.technicianComment || "",

      technicianCommentDate: data.technicianCommentDate?.slice(0, 10) || "",

      state: data.state || 0,
    });

    setScales(
      (data.serviceCallScales || []).map((x: any) => {
        const parsed = parseCapacity(x.capacity);

        return {
          ...x,

          capacityValue: parsed.capacityValue,

          division: parsed.division,

          capacityUnit: parsed.capacityUnit,
        };
      }),
    );

    setLoanScale(
      (data.loanScale || []).map((x: any) => {
        const parsed = parseCapacity(x.capacity);

        return {
          ...x,

          capacityValue: parsed.capacityValue,

          division: parsed.division,

          capacityUnit: parsed.capacityUnit,
        };
      }),
    );

    setTechnicians(
      (data.serviceCallTechnicians || []).map((x: any) => ({
        ...x,

        dateWorked: x.dateWorked ? x.dateWorked.slice(0, 10) : "",

        arrival: x.arrival ? x.arrival.slice(11, 16) : "",

        depature: x.depature ? x.depature.slice(11, 16) : "",
      })),
    );
  };

  // ================= ADD TECH =================
  const addTechnician = () => {
    setTechnicians((prev: any[]) => [
      ...prev,

      {
        id: crypto.randomUUID(),

        dateWorked: "",

        hoursWorked: "",

        arrival: "",

        depature: "",

        spareParts: "",

        qty: "",
      },
    ]);
  };

  // ================= REMOVE TECH =================
  const removeTechnician = (index: number) => {
    setTechnicians(technicians.filter((_: any, i: number) => i !== index));
  };

  // ================= UPDATE =================
  const handleSubmit = async (e: any) => {
    e.preventDefault();

    const payload = {
      id: form.id,

      date: form.date ? new Date(form.date).toISOString() : null,

      orderNumber: form.orderNumber,

      no: Number(form.no),

      customerComment: form.customerComment,

      scaleCertified: form.scaleCertified,

      scaleUsedForTrade: form.scaleUsedForTrade,

      tmvCertificateNo: form.tmvCertificateNo,

      customerId: form.customerId || null,

      customerName: form.customerName,

      customerEmail: form.customerEmail,

      customerAddress: form.customerAddress,

      customerPhoneName: form.customerPhoneName,

      customerPhoneNumber: form.customerPhoneNumber,

      signatureCustomerName: form.signatureCustomerName,

      customerSignature: form.customerSignature,

      customerSignedDate: form.customerSignedDate
        ? new Date(form.customerSignedDate).toISOString()
        : null,

      technicianName: form.technicianName,

      technicianComment: form.technicianComment,

      technicianCommentDate: form.technicianCommentDate
        ? new Date(form.technicianCommentDate).toISOString()
        : null,

      state: Number(form.state),

      serviceCallScales: scales,

      loanScale: loanScale.map((x: any) => ({
        ...x,

        signedDate: x.signedDate ? new Date(x.signedDate).toISOString() : null,

        returnDate: x.returnDate ? new Date(x.returnDate).toISOString() : null,

        haveScaleBeenReturned: Number(x.haveScaleBeenReturned),

        scaleType: Number(x.scaleType),
      })),

      serviceCallTechnicians: technicians.map((x: any) => ({
        ...x,

        dateWorked: x.dateWorked ? new Date(x.dateWorked).toISOString() : null,

        arrival: x.arrival ? `${x.dateWorked}T${x.arrival}:00` : null,

        depature: x.depature ? `${x.dateWorked}T${x.depature}:00` : null,

        hoursWorked: Number(x.hoursWorked),

        qty: Number(x.qty),
      })),
    };

    const success = await updateServiceCall(payload);

    if (success) {
      navigate(
        `/service-calls?page=${page}&search=${encodeURIComponent(search)}&state=${state}&unassigned=${unassigned}`,
      );
    }
  };

  // ================= SELECT CUSTOMER =================
  const handleSelectCustomer = (customer: any) => {
    const firstAddress = customer?.addresses?.[0];

    const firstPhone = customer?.customerPhoneNumbers?.[0];

    const fullAddress = [
      firstAddress?.addressLine1,
      firstAddress?.addressLine2,
      firstAddress?.city,
      firstAddress?.state,
      firstAddress?.postalCode,
    ]
      .filter(Boolean)
      .join(", ");

    setForm({
      ...form,

      customerId: customer.id || "",

      customerName: customer.name || "",

      customerEmail: customer.email || "",

      customerAddress: fullAddress,

      customerPhoneName: firstPhone?.name || "",

      customerPhoneNumber: firstPhone?.phoneNumber || "",
    });

    setShowCustomerDropdown(false);
  };

  return (
    <DashboardLayout>
      <div className="p-4 md:p-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-3xl font-bold">Edit Service Call</h1>

          <select
            value={form.state}
            onChange={(e) =>
              setForm({
                ...form,
                state: Number(e.target.value),
              })
            }
            className="border rounded-xl px-4 py-3"
          >
            <option value={0}>Pending</option>

            <option value={1}>In Progress</option>

            <option value={2}>Completed</option>

            <option value={3}>Cancelled</option>

            <option value={4}>On Hold</option>

            <option value={5}>Rescheduled</option>

            <option value={6}>Rejected</option>
          </select>
        </div>

        <form onSubmit={handleSubmit} className="space-y-8">
          {/* ================= CUSTOMER DETAILS ================= */}
          <div className="bg-white border-2 border-slate-200 rounded-3xl p-8">
            <div className="space-y-5">
              {/* CUSTOMER NAME */}
              <div className="relative" ref={customerDropdownRef}>
                <label className="block text-[15px] font-semibold mb-2">
                  Customer Name
                </label>

                <input
                  value={form.customerName}
                  onFocus={() => setShowCustomerDropdown(true)}
                  onChange={(e) => {
                    setForm({
                      ...form,

                      customerName: e.target.value,
                    });

                    setSearch(e.target.value);

                    setShowCustomerDropdown(true);
                  }}
                  className="w-full border-2 border-slate-300 rounded-2xl px-5 py-4 text-[16px]"
                />

                {showCustomerDropdown && (
                  <div className="absolute z-50 bg-white border rounded-2xl shadow-xl w-full mt-2 max-h-72 overflow-auto">
                    <button
                      type="button"
                      onClick={() => setShowCustomerDropdown(false)}
                      className="w-full text-left px-4 py-4 bg-primary text-white font-semibold"
                    >
                      Manual Entry
                    </button>

                    {customers.map((x: any) => (
                      <button
                        key={x.id}
                        type="button"
                        onClick={() => handleSelectCustomer(x)}
                        className="w-full text-left px-4 py-4 border-b hover:bg-slate-100"
                      >
                        {x.name}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* CUSTOMER COMMENT */}
              <div>
                <label className="block text-[15px] font-semibold mb-2">
                  Customer Comment
                </label>

                <textarea
                  rows={3}
                  maxLength={300}
                  value={form.customerComment || ""}
                  onChange={(e) => {
                    const value = e.target.value;

                    const lines = value.split("\n");

                    // Allow maximum 3 lines
                    if (lines.length <= 3) {
                      setForm({
                        ...form,

                        customerComment: value,
                      });
                    }
                  }}
                  placeholder="Enter customer comment"
                  className="w-full border-2 border-slate-300 rounded-2xl px-5 py-4 resize-none"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {/* EMAIL */}
                <div>
                  <label className="block text-[15px] font-semibold mb-2">
                    Customer Email
                  </label>

                  <input
                    value={form.customerEmail}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        customerEmail: e.target.value,
                      })
                    }
                    className="w-full border-2 border-slate-300 rounded-2xl px-5 py-4"
                  />
                </div>

                {/* CONTACT PERSON */}
                <div>
                  <label className="block text-[15px] font-semibold mb-2">
                    Contact Person
                  </label>

                  <input
                    value={form.customerPhoneName}
                    onChange={(e) =>
                      setForm({
                        ...form,

                        customerPhoneName: e.target.value,
                      })
                    }
                    className="w-full border-2 border-slate-300 rounded-2xl px-5 py-4"
                  />
                </div>

                {/* PHONE */}
                <div>
                  <label className="block text-[15px] font-semibold mb-2">
                    Contact Phone Number
                  </label>

                  <input
                    value={form.customerPhoneNumber}
                    onChange={(e) =>
                      setForm({
                        ...form,

                        customerPhoneNumber: e.target.value,
                      })
                    }
                    className="w-full border-2 border-slate-300 rounded-2xl px-5 py-4"
                  />
                </div>
              </div>

              {/* ADDRESS */}
              <div>
                <label className="block text-[15px] font-semibold mb-2">
                  Customer Address
                </label>

                <textarea
                  rows={5}
                  value={form.customerAddress}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      customerAddress: e.target.value,
                    })
                  }
                  className="w-full border-2 border-slate-300 rounded-2xl px-5 py-4"
                />
              </div>
            </div>
          </div>

          {/* SCALE */}
          <div className="bg-white border rounded-3xl p-6">
            <div className="flex items-center justify-between mb-5">
              <h2 className="text-xl font-bold">Scale Details</h2>
            </div>

            <div className="space-y-5">
              {scales.map((item: any, index: number) => (
                <div key={index} className="border rounded-2xl p-5">
                  <div className="flex justify-end mb-4"></div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    {/* MAKE */}
                    <div>
                      <label className="block mb-2 font-medium">Make</label>

                      <ScaleMakeAsyncSelect
                        value={
                          item.makeId
                            ? {
                                value: item.makeId,
                                label: item.make,
                              }
                            : item.make
                              ? {
                                  value: item.make,
                                  label: item.make,
                                  __isNew__: true,
                                }
                              : null
                        }
                        onChange={(selected: any) => {
                          const updated = [...scales];

                          updated[index] = {
                            ...updated[index],
                            makeId: selected?.__isNew__
                              ? null
                              : selected?.value,
                            make: selected?.label ?? "",
                          };

                          setScales(updated);
                        }}
                      />
                    </div>

                    {/* MODEL */}
                    <div>
                      <label className="block mb-2 font-medium">Model</label>
                      <ScaleModelAsyncSelect
                        value={
                          item.modelId
                            ? {
                                value: item.modelId,
                                label: item.model,
                              }
                            : item.model
                              ? {
                                  value: item.model,
                                  label: item.model,
                                  __isNew__: true,
                                }
                              : null
                        }
                        onChange={(selected: any) => {
                          const updated = [...scales];

                          const capacity = selected?.capacities?.[0];

                          const capacityUnit =
                            capacity?.capacityUnitName ?? "kg";

                          const divisionUnit =
                            capacity?.divisionUnitName ?? capacityUnit;

                          updated[index] = {
                            ...updated[index],

                            modelId: selected?.__isNew__
                              ? null
                              : selected?.value,
                            model: selected?.label ?? "",

                            capacityValue:
                              capacity?.capacity?.toString() ??
                              updated[index].capacityValue,
                            division:
                              capacity?.division?.toString() ??
                              updated[index].division,
                            capacityUnit,

                            capacity: capacity
                              ? `${capacity.capacity}${capacityUnit}x${capacity.division}${divisionUnit}`
                              : updated[index].capacity,
                          };

                          setScales(updated);
                        }}
                      />
                    </div>

                    {/* SERIAL */}
                    <div>
                      <label className="block mb-2 font-medium">
                        Serial Number
                      </label>

                      <input
                        value={item.serialNumber}
                        onChange={(e) => {
                          const updated = [...scales];

                          updated[index].serialNumber = e.target.value;

                          setScales(updated);
                        }}
                        className="w-full border rounded-xl px-4 py-3 uppercase"
                      />
                    </div>

                    {/* CAPACITY */}
                    <div>
                      <label className="block text-[15px] font-semibold mb-2">
                        Capacity
                      </label>

                      <div className="grid grid-cols-3 gap-3">
                        {/* CAPACITY VALUE */}
                        <input
                          type="number"
                          min="0"
                          step="any"
                          placeholder="3000"
                          value={item.capacityValue || ""}
                          onChange={(e) => {
                            const updated = [...scales];

                            const value = e.target.value;

                            updated[index] = {
                              ...updated[index],

                              capacityValue: value,

                              capacity:
                                value &&
                                updated[index].division &&
                                updated[index].capacityUnit
                                  ? `${value}${updated[index].capacityUnit}x${updated[index].division}${updated[index].capacityUnit}`
                                  : "",
                            };

                            setScales(updated);
                          }}
                          className="w-full border rounded-xl px-4 py-3"
                        />

                        {/* DIVISION */}
                        <input
                          type="number"
                          min="0"
                          step="any"
                          placeholder="0.5"
                          value={item.division || ""}
                          onChange={(e) => {
                            const value = e.target.value;

                            if (value.startsWith("-")) return;

                            const updated = [...scales];

                            updated[index] = {
                              ...updated[index],

                              division: value,

                              capacity:
                                updated[index].capacityValue &&
                                value &&
                                updated[index].capacityUnit
                                  ? `${updated[index].capacityValue}${updated[index].capacityUnit}x${value}${updated[index].capacityUnit}`
                                  : "",
                            };

                            setScales(updated);
                          }}
                          className="w-full border rounded-xl px-4 py-3"
                        />

                        {/* UNIT */}
                        <select
                          value={item.capacityUnit || ""}
                          onChange={(e) => {
                            const unit = e.target.value;

                            const updated = [...scales];

                            updated[index] = {
                              ...updated[index],

                              capacityUnit: unit,

                              capacity:
                                updated[index].capacityValue &&
                                updated[index].division
                                  ? `${updated[index].capacityValue}${unit}x${updated[index].division}${unit}`
                                  : "",
                            };

                            setScales(updated);
                          }}
                          className="w-full border rounded-xl px-4 py-3"
                        >
                          <option value="">Unit</option>

                          <option value="kg">kg</option>

                          <option value="g">g</option>

                          <option value="mg">mg</option>

                          <option value="t">t</option>

                          <option value="lb">lb</option>

                          <option value="oz">oz</option>
                        </select>
                      </div>

                      {item.capacity && (
                        <div className="mt-2 text-sm text-slate-600">
                          Capacity Sent:
                          <span className="font-semibold ml-2">
                            {item.capacity}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* BASIC */}
          <div className="bg-white border rounded-3xl p-6">
            <h2 className="text-xl font-bold mb-5">Basic Details</h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div>
                <label className="block mb-2 font-medium">Service Date</label>

                <input
                  type="date"
                  value={form.date}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      date: e.target.value,
                    })
                  }
                  className="w-full border rounded-xl px-4 py-3"
                />
              </div>

              <div>
                <label className="block mb-2 font-medium">Order Number</label>

                <input
                  value={form.orderNumber}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      orderNumber: e.target.value,
                    })
                  }
                  className="w-full border rounded-xl px-4 py-3"
                />
              </div>

              <div>
                <label className="block mb-2 font-medium">
                  TMV Certificate No
                </label>

                <input
                  value={form.tmvCertificateNo}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      tmvCertificateNo: e.target.value,
                    })
                  }
                  className="w-full border rounded-xl px-4 py-3"
                />
              </div>
            </div>

            {/* TOGGLES */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-5">
              {/* SCALE CERTIFIED */}
              <div
                onClick={() =>
                  setForm({
                    ...form,
                    scaleCertified: !form.scaleCertified,
                  })
                }
                className={`cursor-pointer border rounded-2xl p-4 transition-all flex items-center justify-between ${
                  form.scaleCertified
                    ? "bg-primary text-white border-primary"
                    : "bg-white hover:bg-slate-50"
                }`}
              >
                <div>
                  <div className="font-semibold">Scale Certified</div>

                  <div className="text-sm opacity-80">Click to toggle</div>
                </div>

                <div
                  className={`w-6 h-6 rounded-md border-2 flex items-center justify-center ${
                    form.scaleCertified
                      ? "border-white bg-white text-primary"
                      : "border-slate-400"
                  }`}
                >
                  {form.scaleCertified && "✓"}
                </div>
              </div>

              {/* SCALE USED FOR TRADE */}
              <div
                onClick={() =>
                  setForm({
                    ...form,
                    scaleUsedForTrade: !form.scaleUsedForTrade,
                  })
                }
                className={`cursor-pointer border rounded-2xl p-4 transition-all flex items-center justify-between ${
                  form.scaleUsedForTrade
                    ? "bg-primary text-white border-primary"
                    : "bg-white hover:bg-slate-50"
                }`}
              >
                <div>
                  <div className="font-semibold">Scale Used For Trade</div>

                  <div className="text-sm opacity-80">Click to toggle</div>
                </div>

                <div
                  className={`w-6 h-6 rounded-md border-2 flex items-center justify-center ${
                    form.scaleUsedForTrade
                      ? "border-white bg-white text-primary"
                      : "border-slate-400"
                  }`}
                >
                  {form.scaleUsedForTrade && "✓"}
                </div>
              </div>
            </div>
          </div>

          {/* LOAN SCALE */}
          <div className="bg-white border rounded-3xl p-6">
            <div className="flex items-center justify-between mb-5">
              <h2 className="text-xl font-bold">Loan / Hire Scale</h2>
            </div>

            <div className="space-y-5">
              {loanScale.map((item: any, index: number) => (
                <div key={index} className="border rounded-2xl p-5">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                    <div>
                      <label className="block mb-2 font-medium">
                        Scale Type
                      </label>

                      <select
                        value={item.scaleType}
                        onChange={(e) => {
                          const updated = [...loanScale];

                          updated[index].scaleType = Number(e.target.value);

                          setLoanScale(updated);
                        }}
                        className="border rounded-xl px-4 py-3 w-full"
                      >
                        <option value={0}>Loan Scale</option>

                        <option value={1}>Hire Scale</option>
                      </select>
                    </div>

                    <div>
                      <label className="block mb-2 font-medium">Make</label>

                      <ScaleMakeAsyncSelect
                        value={
                          item.makeId
                            ? {
                                value: item.makeId,
                                label: item.make,
                              }
                            : item.make
                              ? {
                                  value: item.make,
                                  label: item.make,
                                  __isNew__: true,
                                }
                              : null
                        }
                        onChange={(selected: any) => {
                          const updated = [...loanScale];

                          updated[index] = {
                            ...updated[index],
                            makeId: selected?.__isNew__
                              ? null
                              : selected?.value,
                            make: selected?.label ?? "",
                          };

                          setLoanScale(updated);
                        }}
                      />
                    </div>

                    <div>
                      <label className="block mb-2 font-medium">Model</label>

                      <ScaleModelAsyncSelect
                        value={
                          item.modelId
                            ? {
                                value: item.modelId,
                                label: item.model,
                              }
                            : item.model
                              ? {
                                  value: item.model,
                                  label: item.model,
                                  __isNew__: true,
                                }
                              : null
                        }
                        onChange={(selected: any) => {
                          const updated = [...loanScale];

                          const capacity = selected?.capacities?.[0];

                          const capacityUnit =
                            capacity?.capacityUnitName ?? "kg";
                          const divisionUnit =
                            capacity?.divisionUnitName ?? capacityUnit;

                          updated[index] = {
                            ...updated[index],

                            modelId: selected?.__isNew__
                              ? null
                              : selected?.value,
                            model: selected?.label ?? "",

                            capacityValue:
                              capacity?.capacity?.toString() ??
                              updated[index].capacityValue,

                            division:
                              capacity?.division?.toString() ??
                              updated[index].division,

                            capacityUnit,

                            capacity: capacity
                              ? `${capacity.capacity}${capacityUnit}x${capacity.division}${divisionUnit}`
                              : updated[index].capacity,
                          };

                          setLoanScale(updated);
                        }}
                      />
                    </div>

                    <div>
                      <label className="block mb-2 font-medium">
                        Serial Number
                      </label>

                      <input
                        value={item.serialNumber}
                        onChange={(e) => {
                          const updated = [...loanScale];

                          updated[index].serialNumber = e.target.value;

                          setLoanScale(updated);
                        }}
                        className="border rounded-xl px-4 py-3 w-full uppercase"
                      />
                    </div>

                    <div>
                      <label className="block text-[15px] font-semibold mb-2">
                        Capacity
                      </label>

                      <div className="grid grid-cols-3 gap-3">
                        {/* CAPACITY VALUE */}
                        <input
                          type="number"
                          min="0"
                          step="any"
                          placeholder="3000"
                          value={item.capacityValue || ""}
                          onChange={(e) => {
                            const updated = [...loanScale];

                            const value = e.target.value;

                            updated[index] = {
                              ...updated[index],

                              capacityValue: value,

                              capacity:
                                value &&
                                updated[index].division &&
                                updated[index].capacityUnit
                                  ? `${value}${updated[index].capacityUnit}x${updated[index].division}${updated[index].capacityUnit}`
                                  : "",
                            };

                            setLoanScale(updated);
                          }}
                          className="w-full border rounded-xl px-4 py-3"
                        />

                        {/* DIVISION */}
                        <input
                          type="number"
                          min="0"
                          step="any"
                          placeholder="0.5"
                          value={item.division || ""}
                          onChange={(e) => {
                            const value = e.target.value;

                            const updated = [...loanScale];

                            updated[index] = {
                              ...updated[index],

                              division: value,

                              capacity:
                                updated[index].capacityValue &&
                                value &&
                                updated[index].capacityUnit
                                  ? `${updated[index].capacityValue}${updated[index].capacityUnit}x${value}${updated[index].capacityUnit}`
                                  : "",
                            };

                            setLoanScale(updated);
                          }}
                          className="w-full border rounded-xl px-4 py-3"
                        />

                        {/* UNIT */}
                        <select
                          value={item.capacityUnit || ""}
                          onChange={(e) => {
                            const unit = e.target.value;

                            const updated = [...loanScale];

                            updated[index] = {
                              ...updated[index],

                              capacityUnit: unit,

                              capacity:
                                updated[index].capacityValue &&
                                updated[index].division
                                  ? `${updated[index].capacityValue}${unit}x${updated[index].division}${unit}`
                                  : "",
                            };

                            setLoanScale(updated);
                          }}
                          className="w-full border rounded-xl px-4 py-3"
                        >
                          <option value="">Unit</option>

                          <option value="kg">kg</option>

                          <option value="g">g</option>

                          <option value="mg">mg</option>

                          <option value="t">t</option>

                          <option value="lb">lb</option>

                          <option value="oz">oz</option>
                        </select>
                      </div>

                      {item.capacity && (
                        <div className="mt-2 text-sm text-slate-600">
                          Capacity Sent:
                          <span className="font-semibold ml-2">
                            {item.capacity}
                          </span>
                        </div>
                      )}
                    </div>

                    <div>
                      <label className="block mb-2 font-medium">
                        Signed By
                      </label>

                      <input
                        value={item.signed}
                        onChange={(e) => {
                          const updated = [...loanScale];

                          updated[index].signed = e.target.value;

                          setLoanScale(updated);
                        }}
                        className="border rounded-xl px-4 py-3 w-full"
                      />
                    </div>

                    <div>
                      <label className="block mb-2 font-medium">
                        Signed Date
                      </label>

                      <input
                        type="datetime-local"
                        value={item.signedDate?.slice(0, 16) || ""}
                        onChange={(e) => {
                          const updated = [...loanScale];

                          updated[index].signedDate = e.target.value;

                          setLoanScale(updated);
                        }}
                        className="border rounded-xl px-4 py-3 w-full"
                      />
                    </div>

                    <div>
                      <label className="block mb-2 font-medium">
                        Return Status
                      </label>

                      <select
                        value={item.haveScaleBeenReturned}
                        onChange={(e) => {
                          const updated = [...loanScale];

                          updated[index].haveScaleBeenReturned = Number(
                            e.target.value,
                          );

                          setLoanScale(updated);
                        }}
                        className="border rounded-xl px-4 py-3 w-full"
                      >
                        <option value={0}>No</option>

                        <option value={1}>Yes</option>
                      </select>
                    </div>

                    <div>
                      <label className="block mb-2 font-medium">
                        Return Date
                      </label>

                      <input
                        type="datetime-local"
                        value={item.returnDate?.slice(0, 16) || ""}
                        onChange={(e) => {
                          const updated = [...loanScale];

                          updated[index].returnDate = e.target.value;

                          setLoanScale(updated);
                        }}
                        className="border rounded-xl px-4 py-3 w-full"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* TECHNICIANS */}
          <div className="bg-white border rounded-3xl p-6">
            <div className="flex items-center justify-between mb-5">
              <h2 className="text-xl font-bold">Technician Records</h2>
            </div>

            {/* TECHNICIAN SECTION */}
            <div className="mt-5 mb-5">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-2">
                {/* TECHNICIAN NAME */}
                <div>
                  <label className="block mb-2 font-medium">
                    Technician Name
                  </label>

                  <TechnicianAsyncSelect
                    value={form.technicianName}
                    onChange={(value) =>
                      setForm({
                        ...form,
                        technicianName: value,
                      })
                    }
                  />
                </div>

                {/* TECHNICIAN COMMENT DATE */}
                <div>
                  <label className="block mb-2 font-medium">
                    Technician Comment Date
                  </label>

                  <input
                    type="date"
                    value={
                      form.technicianCommentDate
                        ? form.technicianCommentDate.slice(0, 10)
                        : ""
                    }
                    onChange={(e) =>
                      setForm({
                        ...form,

                        technicianCommentDate: e.target.value,
                      })
                    }
                    className="w-full border rounded-xl px-4 py-3"
                  />
                </div>
              </div>

              {/* TECHNICIAN COMMENT */}
              <div>
                <label className="block mb-2 font-medium">
                  Technician Comment
                </label>

                <textarea
                  rows={3}
                  value={form.technicianComment || ""}
                  onChange={(e) => {
                    const value = e.target.value;

                    const lines = value.split("\n");

                    if (lines.length <= 3) {
                      setForm({
                        ...form,

                        technicianComment: value,
                      });
                    }
                  }}
                  className="w-full border rounded-xl px-4 py-3 resize-none"
                  placeholder="Enter technician comment"
                />
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full min-w-[1200px] border">
                <thead className="bg-slate-100">
                  <tr>
                    <th className="border p-3">Date Worked</th>

                    <th className="border p-3">Arrival</th>

                    <th className="border p-3">Departure</th>

                    <th className="border p-3">Hours</th>

                    <th className="border p-3 min-w-[350px]">Spare Parts</th>

                    <th className="border p-3">Qty</th>

                    <th className="border p-3">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {technicians.map((tech: any, index: number) => (
                    <tr key={index} className="align-top">
                      {/* DATE WORKED */}
                      <td className="border p-2 min-w-[170px]">
                        <input
                          type="date"
                          value={tech.dateWorked || ""}
                          onChange={(e) => {
                            const updated = [...technicians];

                            updated[index].dateWorked = e.target.value;

                            setTechnicians(updated);
                          }}
                          className="w-full border rounded-lg px-3 py-2"
                        />
                      </td>

                      {/* ARRIVAL */}
                      <td className="border p-2 min-w-[140px]">
                        <select
                          value={tech.arrival || ""}
                          onChange={(e) => {
                            const updated = [...technicians];

                            updated[index].arrival = e.target.value;

                            // AUTO HOURS
                            if (updated[index].depature) {
                              const start = new Date(
                                `1970-01-01T${updated[index].arrival}:00`,
                              );

                              const end = new Date(
                                `1970-01-01T${updated[index].depature}:00`,
                              );

                              const diff =
                                (end.getTime() - start.getTime()) /
                                (1000 * 60 * 60);

                              updated[index].hoursWorked =
                                diff > 0 ? Number(diff.toFixed(2)) : 0;
                            }

                            setTechnicians(updated);
                          }}
                          className="w-full border rounded-lg px-3 py-2"
                        >
                          <option value="">Select</option>

                          {Array.from(
                            {
                              length: 48,
                            },
                            (_, i) => {
                              const hour = Math.floor(i / 2)
                                .toString()
                                .padStart(2, "0");

                              const minute = i % 2 === 0 ? "00" : "30";

                              const time = `${hour}:${minute}`;

                              return (
                                <option key={time} value={time}>
                                  {time}
                                </option>
                              );
                            },
                          )}
                        </select>
                      </td>

                      {/* DEPARTURE */}
                      <td className="border p-2 min-w-[140px]">
                        <select
                          value={tech.depature || ""}
                          onChange={(e) => {
                            const updated = [...technicians];

                            updated[index].depature = e.target.value;

                            // AUTO HOURS
                            if (updated[index].arrival) {
                              const start = new Date(
                                `1970-01-01T${updated[index].arrival}:00`,
                              );

                              const end = new Date(
                                `1970-01-01T${updated[index].depature}:00`,
                              );

                              const diff =
                                (end.getTime() - start.getTime()) /
                                (1000 * 60 * 60);

                              updated[index].hoursWorked =
                                diff > 0 ? Number(diff.toFixed(2)) : 0;
                            }

                            setTechnicians(updated);
                          }}
                          className="w-full border rounded-lg px-3 py-2"
                        >
                          <option value="">Select</option>

                          {Array.from(
                            {
                              length: 48,
                            },
                            (_, i) => {
                              const hour = Math.floor(i / 2)
                                .toString()
                                .padStart(2, "0");

                              const minute = i % 2 === 0 ? "00" : "30";

                              const time = `${hour}:${minute}`;

                              return (
                                <option key={time} value={time}>
                                  {time}
                                </option>
                              );
                            },
                          )}
                        </select>
                      </td>

                      {/* HOURS */}
                      <td className="border p-2 min-w-[120px]">
                        <input
                          type="number"
                          value={tech.hoursWorked || 0}
                          readOnly
                          className="w-full border rounded-lg px-3 py-2 bg-slate-100"
                        />
                      </td>

                      {/* SPARE PARTS */}
                      <td className="border p-2 min-w-[350px]">
                        <input
                          type="text"
                          value={tech.spareParts}
                          onChange={(e) => {
                            const updated = [...technicians];

                            updated[index].spareParts = e.target.value;

                            setTechnicians(updated);
                          }}
                          className="w-full border rounded-lg px-3 py-2"
                        />
                      </td>

                      {/* QTY */}
                      <td className="border p-2 min-w-[120px]">
                        <input
                          type="number"
                          value={tech.qty}
                          onChange={(e) => {
                            const updated = [...technicians];

                            updated[index].qty = e.target.value;

                            setTechnicians(updated);
                          }}
                          className="w-full border rounded-lg px-3 py-2"
                        />
                      </td>

                      {/* REMOVE */}
                      <td className="border p-2 min-w-[120px]">
                        <button
                          type="button"
                          onClick={() => removeTechnician(index)}
                          className="bg-red-100 text-red-600 px-4 py-2 rounded-lg"
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <button
                type="button"
                onClick={addTechnician}
                className="bg-primary text-white px-4 py-2 rounded-xl mt-5 mb-5"
              >
                + Add
              </button>
            </div>
          </div>

          {/* ACTION */}
          <div className="flex justify-end">
            <button
              type="submit"
              className="bg-primary text-white px-6 py-3 rounded-2xl font-semibold"
            >
              Update Service Call
            </button>
          </div>
        </form>
      </div>
    </DashboardLayout>
  );
};

export default EditServiceCall;
